import {Divider, SvgIcon} from "@mui/material";
import "./performanceStats.tsx.scss";
import styles from "./DetectionsStats.module.scss";
import animalIcon from "../detectionsTable/icons/ANIMAL.svg";
import animalZeroIcon from "../detectionsTable/icons/ANIMAL_ZERO.svg";
import truckIcon from "../detectionsTable/icons/TRUCK.svg";
import carIcon from "../detectionsTable/icons/CAR.svg";
import carZeroIcon from "../detectionsTable/icons/CAR_ZERO.svg";
import obstacleIcon from "../detectionsTable/icons/OBSTACLE.svg";
import obstacleZeroIcon from "../detectionsTable/icons/OBSTACLE_ZERO.svg";
import personIcon from "../detectionsTable/icons/PERSON.svg";
import personZeroIcon from "../detectionsTable/icons/PERSON_ZERO.svg";
import locomotiveIcon from "../detectionsTable/icons/LOCOMOTIVE.svg";
import locomotiveZeroIcon from "../detectionsTable/icons/LOCOMOTIVE_ZERO.svg";
import breakingShoeIcon from "../detectionsTable/icons/BREAKING_SHOE.svg";
import breakingShoeZeroIcon from "../detectionsTable/icons/BREAKING_SHOE_ZERO.svg";
import endOfRailIcon from "../detectionsTable/icons/END_OF_TRACKS.svg";
import endOfRailZeroIcon from "../detectionsTable/icons/END_OF_TRACKS_ZERO.svg";
import backSwitchIcon from "../detectionsTable/icons/SWITCH_FAILED.svg";
import backSwitchZeroIcon from "../detectionsTable/icons/SWITCH_FAILED_ZERO.svg";
import wagonIcon from "../detectionsTable/icons/sideswipe.svg";
import wagonZeroIcon from "../detectionsTable/icons/sideswipe_zero.svg";
import PerformanceStatsService from "../../client-api/services/performanceStats";
import {observer} from "mobx-react-lite";
import SystemStatusBar from "../systemStatusBar/SystemStatusBar";

import LineChart from "../../components/lineChart/LineChart";
import uiStore from "../../store/UiStore";
import {SystemType} from "../../common/systemType";


const DetectionsStats = () => {

    const getTotalBYClasses = (classes_count: any) => {

        return (classes_count.Person || 0) +
            (classes_count.Animal || 0) +
            (classes_count.Car || 0) + (classes_count.Bike || 0) +
            (classes_count.Obstacle || 0) +
            (classes_count.Locomotive || 0) + (classes_count.Train || 0) +
            (classes_count.Wagon || 0) +
            (classes_count.Back_Switch || 0) +
            (classes_count.End_Of_Rail || 0);

    }

    let stats = PerformanceStatsService.GetPerformanceReportStats();
    return (
        <div className={styles.detectionsStatsWrapper}>

            <div className={styles.statsTitle}>EVENTS CLASSIFICATION</div>
            <div className={styles.lowStatsBar}>
                <div className={styles.statsBarTotalContainer}>
                    <div className={styles.statsBarTotalCount}>{getTotalBYClasses(stats.classes_count)}</div>
                    <div className={styles.statsBarTotalCountTitle}>Safety Events</div>
                </div>
                <div className={styles.statsBarItemsList}>
                    <div className={styles.statsBarItem}>
                        <div className={styles.statIcon}><img className={styles.statIcon}
                                                              src={stats.classes_count.Person ? personIcon : personZeroIcon}/>
                        </div>
                        <div
                            className={stats.classes_count.Person ? styles.statProgress : styles.statProgressEmpty}></div>
                        <div
                            className={stats.classes_count.Person ? styles.statBarCount : styles.statBarCount}>{stats.classes_count.Person || 0}</div>
                    </div>
                    <div className={styles.statsBarItem}>
                        <div className={styles.statIcon}><img className={styles.statIcon}
                                                              src={stats.classes_count.Animal ? animalIcon : animalZeroIcon}/>
                        </div>
                        <div
                            className={stats.classes_count.Animal ? styles.statProgress : styles.statProgressEmpty}></div>
                        <div className={styles.statBarCount}>{stats.classes_count.Animal || 0}</div>
                    </div>
                    <div className={styles.statsBarItem}>
                        <div className={styles.statIcon}><img className={styles.statIcon}
                                                              src={stats.classes_count.Car ? carIcon : carZeroIcon}/>
                        </div>
                        <div className={stats.classes_count.Car ? styles.statProgress : styles.statProgressEmpty}></div>
                        <div
                            className={styles.statBarCount}>{(stats.classes_count.Car || 0) + (stats.classes_count.Bike || 0)}</div>
                    </div>
                    <div className={styles.statsBarItem}>
                        <div className={styles.statIcon}><img className={styles.statIcon}
                                                              src={stats.classes_count.Obstacle ? obstacleIcon : obstacleZeroIcon}/>
                        </div>
                        <div
                            className={stats.classes_count.Obstacle ? styles.statProgress : styles.statProgressEmpty}></div>
                        <div className={styles.statBarCount}>{stats.classes_count.Obstacle || 0}</div>
                    </div>
                    <div className={styles.statsBarItem}>
                        <div className={styles.statIcon}><img className={styles.statIcon}
                                                              src={(stats.classes_count.Locomotive || stats.classes_count.Train) ? locomotiveIcon : locomotiveZeroIcon}/>
                        </div>
                        <div
                            className={(stats.classes_count.Locomotive || stats.classes_count.Train) ? styles.statProgress : styles.statProgressEmpty}></div>
                        <div
                            className={styles.statBarCount}>{(stats.classes_count.Locomotive || 0) + (stats.classes_count.Train || 0)}</div>
                    </div>

                    {(uiStore.getSelectedSystemType() === SystemType.SwitchYard.valueOf()) &&
                        <>

                            <div className={styles.statsBarItem}>
                                <div className={styles.statIcon}><img className={styles.statIcon}
                                                                      src={stats.classes_count.Wagon ? wagonIcon : wagonZeroIcon}/>
                                </div>
                                <div
                                    className={stats.classes_count.Wagon ? styles.statProgress : styles.statProgressEmpty}></div>
                                <div className={styles.statBarCount}>{(stats.classes_count.Wagon || 0)}</div>

                            </div>
                            <div className={styles.statsBarItem}>
                                <div className={styles.statIcon}><img className={styles.statIcon}
                                                                      src={stats.classes_count.Back_Switch ? backSwitchIcon : backSwitchZeroIcon}/>
                                </div>
                                <div
                                    className={stats.classes_count.Back_Switch ? styles.statProgress : styles.statProgressEmpty}></div>
                                <div className={styles.statBarCount}>{(stats.classes_count.Back_Switch || 0)}</div>
                            </div>
                            <div className={styles.statsBarItem}>
                                <div className={styles.statIcon}><img className={styles.statIcon}
                                                                      src={stats.classes_count.End_Of_Rail ? endOfRailIcon : endOfRailZeroIcon}/>
                                </div>
                                <div
                                    className={stats.classes_count.End_Of_Rail ? styles.statProgress : styles.statProgressEmpty}></div>
                                <div className={styles.statBarCount}>{(stats.classes_count.End_Of_Rail || 0)}</div>
                            </div>


                        </>
                    }

                </div>
            </div>

        </div>


    );
};

export default observer(DetectionsStats);
